module.exports = __webpack_public_path__ + "static/media/apc-vle-therapeutics.784d00af.jpg";